import React, { createContext, useContext } from 'react';
import { IPlatform } from './types';

const PlatformContext = createContext<IPlatform | null>(null);

export const PlatformProvider: React.FC<{
  platform: IPlatform;
  children: React.ReactNode;
}> = ({ platform, children }) => (
  <PlatformContext.Provider value={platform}>
    {children}
  </PlatformContext.Provider>
);

export const usePlatform = (): IPlatform => {
  const context = useContext(PlatformContext);
  if (!context) {
    throw new Error('usePlatform must be used within a PlatformProvider');
  }
  return context;
};